import {
    CURRENT_USER_URL,
    LOGIN_URL,
    LOGOUT_URL,
    CHANGE_PASSWORD_URL,
    CHANGE_EMAIL_URL,
    CHANGE_PHONE_URL,
    UPLOAD_AVATAR_URL,
    UPLOAD_MEMBER_PHOTO_URL,
    UPLOAD_MEMBER_FILMAMATEUR_URL,
    SAVE_MEMBER_FILMAMATEUR_URL,
    DELETE_MEMBER_FILMAMATEUR_URL
} from './constants';

import {CancelToken, isCancel} from 'axios';

import {
    getAxios,
    formDataToRequestParams,
//    getRequest
} from './axios'

import {
    responseResolveInterceptor
} from './interceptors';

export function getCurrentUser(params) {
    let axios = getAxios();

    return axios.get(CURRENT_USER_URL, {params});
}

export function registerUser(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/register/',
        method: 'post',
        data: formDataToRequestParams(data)
    });
}

export function activateRegisterUser(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/activate/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}

export function activateUserByCode(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/activate/by-code/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function requestActivationSms(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/activate/request-sms/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function updateActivationEmail(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/activate/update-email/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function login(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: LOGIN_URL,
        method: 'post',
        data: formDataToRequestParams(data)
    });
}

let authTokenData = null;

export function setAuthTokenData(data) {
    authTokenData = data;
}

export function addAuthTokenData(formData) {
    if (authTokenData === null || !authTokenData.uid) return formData;

    return {
        ...formData,
        __uid: authTokenData.uid,
        __auth_token: authTokenData.token
    }
}

export function saveCurrentUser(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function getMember(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}

/*
// todo: rewrite backend-helper fn's using getRequest/postRequest abstractions
export function getMember() {
    return getRequest(
        '/member/',
        addAuthTokenData({}),
        [memberResponseInterceptor]
    )
}
*/

export function logout() {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: LOGOUT_URL,
        method: 'post'
    });
}

export function changeNick({nick}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/change/nick/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({nick}))
    });
}

export function changePassword(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: CHANGE_PASSWORD_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function changeEmail(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: CHANGE_EMAIL_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function changePhone(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: CHANGE_PHONE_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

/**
 *
 * @param {string} avatarData
 * @return {Promise}
 */
export function uploadAvatarData(avatarData) {
    let formData = new FormData();
    formData.append('avatar_data', avatarData);

    let authTokenData = addAuthTokenData();

    for (let name in authTokenData) {
        formData.append(name, authTokenData[name]);
    }

    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.post(UPLOAD_AVATAR_URL, formData);
}

/**
 *
 * @param {object} data
 * @param {File} file
 *
 * @return {Promise}
 */
export function uploadMemberPhoto(data, file) {
    let formData = new FormData();
    formData.append('userfile', file);

    data = addAuthTokenData(data);

    for (let name in data) {
        formData.append(name, data[name]);
    }

    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: UPLOAD_MEMBER_PHOTO_URL,
        method: 'post',
        data: formData
    });
}

export function deleteMemberPhoto(id) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/photo/delete/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function saveMemberPhoto(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/photo/save/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

/**
 *
 * @param {File} file
 * @param {function} cancelFn
 * @param {function} onUploadProgress
 *
 * @return {{promise: Promise, cancelFn: function, isCancel: function}}
 */
export function uploadMemberFilmAmateur(file, onUploadProgress) {
    let formData = new FormData();
    formData.append('userfile', file);

    let data = addAuthTokenData({});

    for (let name in data) {
        formData.append(name, data[name]);
    }

    let axios = getAxios({uploadURL: true});

    axios.interceptors.response.use(responseResolveInterceptor);

    let source = CancelToken.source();

    let promise = axios.request({
        url: UPLOAD_MEMBER_FILMAMATEUR_URL,
        method: 'post',
        data: formData,
        cancelToken: source.token,
        onUploadProgress
    });

    return {
        promise,
        cancelFn: source.cancel,
        isCancel
    };
}

export function deleteMemberFilmAmateur(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: DELETE_MEMBER_FILMAMATEUR_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function saveMemberFilmAmateur(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: SAVE_MEMBER_FILMAMATEUR_URL,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function saveVirtualGift(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    let formData = new FormData();
    data = addAuthTokenData(data);
    for (let name in data) {
        formData.append(name, data[name])
    }

    return axios.request({
        url: '/member/virtual_gift/save/',
        method: 'post',
        data: formData
    });
}

export function deleteMemberVirtualGift({id}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/virtual_gift/delete/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function toggleMemberVirtualGiftHidden({id}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/virtual_gift/hide/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function addGuestbookMessage({recipient_id, message}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/guestbook/add/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({recipient_id, message}))
    });
}

export function deleteGuestbookMessage(id) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/guestbook/delete/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function disableMyGuestbook(guestbookDisabled) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/guestbook/disable/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({guestbook_disabled: guestbookDisabled ? '1' : '0'}))
    });
}

export function followProfile(id) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/follow/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function unfollowProfile(id) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/unfollow/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function blackListUser({id, reason, type}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/block/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id, reason, type}))
    });
}

export function unBlackListUser(id) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/unblock/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function addBadProfile({id, comments}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/add_bad_profile/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id, comments}))
    });
}

/**
 *
 * @param {File} file
 * @param {function} cancelFn
 * @param {function} onUploadProgress
 *
 * @return {{promise: Promise, cancelFn: function, isCancel: function}}
 */
export function uploadWallPost(file, onUploadProgress) {
    let formData = new FormData();
    formData.append('userfile', file);

    let data = addAuthTokenData({});

    for (let name in data) {
        formData.append(name, data[name]);
    }

    let axios = getAxios({uploadURL: true});

    axios.interceptors.response.use(responseResolveInterceptor);

    let source = CancelToken.source();

    let promise = axios.request({
        url: '/member/wall/upload/',
        method: 'post',
        data: formData,
        cancelToken: source.token,
        onUploadProgress
    });

    return {
        promise,
        cancelFn: source.cancel,
        isCancel
    };
}

export function deleteVideo(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/amateur_film/delete/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function deleteWallPost(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/wall/delete/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function saveWallPost(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/wall/save/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function setFCMToken({ token }) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/pushapi/set-token/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({ token }))
    });
}

export function deleteAccount() {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/request-removal/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({confirmed: 1}))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/member.js